import { useRef } from 'react';

/*
    "Standard" card design of a <li> with an <a> tag wrapping the contents of the
    card to make it clickable isn't accessible as it causes the screen reader the announce
    the entire card at once.

    However, UX wise we still want the whole card surface to be clickable. This blog goes
    into further details https://inclusive-components.design/cards/ but has a hacky conclusion
    that we don't use.
*/
function useAccessibleCard() {
  const linkRef = useRef();
  const BUTTONS_TO_HANDLE = [0]; // 0 = Left mouse
  const ignoreUnwantedEvents = (event, callback) => {
    if (!BUTTONS_TO_HANDLE.includes(event.button)) {
      return;
    }
    callback(event);
  };
  const cardRefCallback = cardElement => {
    // cardElement is being unmounted
    if (cardElement === null) {
      return;
    }

    // Determine if a click or a drag is happening
    let isDragging = false;
    const isMovingHandler = event => {
      // check if we care about the action based on button used
      ignoreUnwantedEvents(event, () => {
        // if the mouse moves we are dragging
        isDragging = true;
      });
    };
    cardElement.addEventListener('mousedown', event => {
      // check if we care about the action based on button used
      ignoreUnwantedEvents(event, () => {
        // start listening for movement
        cardElement.addEventListener('mousemove', isMovingHandler);
        // reset drag to no
        isDragging = false;
      });
    });
    cardElement.addEventListener('mouseup', event => {
      // check if we care about the action based on button used
      ignoreUnwantedEvents(event, () => {
        // Check if a drag has happened, if not && also don't trigger the click if its happening on or inside the link
        if (!isDragging && !linkRef?.current.contains(event.target)) {
          // dispatch a new click event based on the existing event (in order to capture modifier keys held)
          linkRef?.current.dispatchEvent(new MouseEvent('click', event));
        }

        // stop listening for movement
        cardElement.removeEventListener('mousemove', isMovingHandler);

        // either way, reset the drag to false
        isDragging = false;
      });
    });
  };
  return {
    cardRef: cardRefCallback,
    linkRef
  };
}
useAccessibleCard.propTypes = {};
useAccessibleCard.defaultProps = {};
export default useAccessibleCard;